import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { compose } from 'recompose';
import filterList from '../../../common/actions/lists';
import { parseQuery } from '../../../common/services/parseQuery';
import { IRootState } from '../../../typings';
import { addLineupSurvey, fetchLineupSurveys } from '../action';

type IOwnProps = RouteComponentProps;

const mapDispatchToProps = {
  fetchLineupSurveys,
  addLineupSurvey,
  filterList,
};

const mapStateToProps = (state: IRootState, ownProps: IOwnProps) => ({
  me: state.me,
  lineupSurveys: state.lineupSurveyList.list,
  pagination: state.lineupSurveyList.pagination,
  fetching: state.lineupSurveyList.fetching,
  total: state.lineupSurveyList.totalItems,
  query: parseQuery(ownProps.location.search),
});

export type IComponentProps = typeof mapDispatchToProps &
  ReturnType<typeof mapStateToProps> &
  InjectedIntlProps &
  IOwnProps;

const reduxConnector = connect(
  mapStateToProps,
  mapDispatchToProps
);

export const connector = compose<IComponentProps, IOwnProps>(
  reduxConnector,
  injectIntl
);
